import enUS from './en-US.json.js';

var enUSTranslations = enUS;

export { enUSTranslations };
